<template>
  <div class="fact-container">
    <div id="factoid">
      <bandwidth-svg />
      <video-svg />
      <latency-svg />
    </div>
  </div>
</template>

<script>
import VideoSvg from "./factoids/VideoSvg.vue";
import BandwidthSvg from "./factoids/BandwidthSvg";
import LatencySvg from "./factoids/LatencySvg";

export default {
  name: "Factoid",
  components: {
    VideoSvg,
    BandwidthSvg,
    LatencySvg
  }
};
</script>

<style lang="scss">
@mixin browser($browsers: Mozilla) {
  @each $browser in $browsers {
    html[data-browser*="#{$browser}"] & {
      @content;
    }
  }
}

.fact-container {
  width: 100%;
  overflow: hidden;
  min-width: 100%;
  background-color: #000;
}

#factoid {
  background-color: #000;
  font-family: Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  font-weight: bold;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  
  @include browser("Trident") {
    height: 360px;
  }

  svg {
    max-width: 33%;
    @include media-breakpoint-down(sm) {
      max-width: 100%;
      width: 100%;
      margin: 0 auto;
    }
  }

  @include media-breakpoint-up(md) {
    padding: 50px 40px;
  }
  @include media-breakpoint-up(lg) {
    max-width: 1000px;
    padding: 50px 0px;
  }
  @include media-breakpoint-up(xl) {
    max-width: 1140px;
    padding: 50px 0px;
  }
}
</style>